// src/components/lead/sections/NotesSection.tsx
import type { ExtractedLeadV2 } from "../../../types/lead";
import type { UpdateLeadFieldFn } from "../../../types/leadActions";

type Props = {
	e: ExtractedLeadV2;
	updateCurrentLeadField: UpdateLeadFieldFn;
};

export function NotesSection(props: Props) {
	const { e, updateCurrentLeadField } = props;

	return (
		<div data-app-panel="NotesSection" className="mt-6"> {/* Notes */}
			<div className="text-gray-500 text-sm uppercase tracking-wide">
				Notes
			</div>
			<textarea
				// Mobile: 5 rows worth (~8rem). md:+ bumps to ~10 rows (~16rem)
				// per dev-sync note 4569f693 Part B1. B3 (Notes as co-equal lane
				// on lg:+) is part of the desktop-layout slice owned elsewhere.
				id="lead-notes-textarea"
				className="font-mono bg-gray-50 p-3 sm:p-4 rounded-xl text-sm w-full min-h-[8rem] md:min-h-[16rem] max-h-64 md:max-h-[24rem] overflow-y-auto resize-y"
				rows={5}
				placeholder="Site details, HOA rules, access issues, color requirements, etc."
				value={e.notes || ""}
				onChange={(ev) => updateCurrentLeadField("notes", ev.target.value)}
			/>
		</div>
	);
}

